module.exports = __webpack_public_path__ + "static/media/warning.8369a9f8.svg";